var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var {
  AppRegistry,
  StyleSheet,
  View,
  Text,
  StyleSheet,
  Platform,
  PixelRatio,
} = ReactNative;

var ReUpText = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      style : {},
      fontKey:null,
      isTitle:false,
      isSuperTitle:false,
      shrinksAtLength:100,
      children:<View />
    }
  },

  render: function()
  {
    var {appManager, style, fontKey, children, isTitle, isSuperTitle, shrinksAtLength, ...otherProps} = this.props;

    var fontScale = appManager == null ? 1 : appManager._fontScale;
    var additionalFontPoints = 0;
    if( fontScale >= 3 ) additionalFontPoints = 4;
    if( fontScale >= 2 ) additionalFontPoints = 2;

    var shouldShrink = typeof children !== 'undefined' && children != null && children.length >= shrinksAtLength;
    var overridableStyle = {fontSize:shouldShrink ? 12 : 14+additionalFontPoints, backgroundColor:'transparent', textAlign:'left'};
    if( isTitle ) overridableStyle = {fontSize:shouldShrink ? 14 : 16+additionalFontPoints, fontWeight:'bold', backgroundColor:'transparent', textAlign:'left'};
    if( isSuperTitle ) overridableStyle = {fontSize:shouldShrink ? 12 : 18, fontWeight:'bold', backgroundColor:'transparent', textAlign:'left'};

    var overrideStyle = {};
    if( appManager != null && typeof appManager !== 'undefined' )
    {
      if( this.props.fontKey != null ) overrideStyle.fontFamily = this.props.appManager.getFontForKey(this.props.fontKey);
      else
      {
        var isBold = isTitle || isSuperTitle || overridableStyle.fontWeight == 'bold' || style.fontWeight == 'bold';
        if( isBold ) overrideStyle.fontFamily = this.props.appManager.getFontForKey("Bold");
        else overrideStyle.fontFamily = this.props.appManager.getFontForKey("Regular");
      }

      // if( overrideStyle.fontFamily.startsWith("Vonne") )
      // {
      //   var paddingTop = 0;
      //   if( typeof style.paddingTop !== 'undefined' ) paddingTop = style.paddingTop;
      //   if( typeof style === 'array' )
      //   {
      //     for( var i = 0; i < style.length; i++ )
      //     {
      //         if( typeof style[i].paddingTop !== 'undefined' ) paddingTop += style[i].paddingTop;
      //     }
      //   }
      //   overrideStyle.paddingTop = 6 + paddingTop;
      //   if( typeof style.fontSize !== 'undefined' ) overrideStyle.paddingTop = style.fontSize/3 + paddingTop;
      //
      // }

    }
    else {
      // paddingTop = 10
    }

    // TODO: this should be in the config
    if( Platform.OS === 'web' )
    {
      overrideStyle.fontFamily = "Helvetica";
    }

    var overallStyle = StyleSheet.flatten([overridableStyle, style, overrideStyle]);
    // if( typeof overallStyle.fontSize !== 'undefined' ) overallStyle.fontSize = overallStyle.fontSize / PixelRatio.getFontScale();

    return (
      <Text allowFontScaling={false} style={overallStyle} {...otherProps}>
        {(typeof children !== 'undefined' && children != null) ? children : ""}
      </Text>
    )
  }
});

module.exports = ReUpText;
